import { render, staticRenderFns } from "./ClientRole.vue?vue&type=template&id=27f5539b"
import script from "./ClientRole.vue?vue&type=script&lang=js"
export * from "./ClientRole.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports